import { BetterInputNumber } from '@/shared/BetterInputNumber'
import {
  alarmConditionItems,
  alarmCondMethodItems,
  getOptions
} from '@/shared/SelectData'
import {
  MacroItem,
  MacroScheduleItem,
  PlcItem,
  VariableItem
} from '@/template/interface'
import { getAddressOption } from '@/utils/dataType'
import { getFormatMessage } from '@/utils/utils'
import { Col, Form, FormInstance, InputNumber, Radio, Row, Select } from 'antd'
import React, { useEffect, useState } from 'react'

export const TemplateMacroPlan = (props: {
  form: FormInstance<MacroScheduleItem>
  item?: MacroItem
  variables?: VariableItem[]
  plcs?: PlcItem[]
}) => {
  const [mode, setMode] = useState<number>(0)
  const [dataType, setDataType] = useState<number>()
  const [condMethod, setCondMethod] = useState<number>(0)
  const formatMessage = getFormatMessage()
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  }
  const formItemStyle = { marginBottom: 0 }

  const handleVariableChange = (id: string) => {
    const variable = props.variables?.find((x) => x.id == id)
    setDataType(variable?.dataType)
    const values = props.form.getFieldsValue()
    values.condition!.operate1 = variable && variable.dataType == 0 ? 1 : 0
    props.form.setFieldsValue(values)
  }

  const handleCondMethodChange = (value: number) => {
    setCondMethod(value)
  }

  const hanldeModeChange = (mode: number) => {
    setMode(mode)
    const values = props.form.getFieldsValue()
    values.mode = mode
    if (mode == 1) {
      values.cycle = 5
    }
    if (mode == 2) {
      const filterVars = props.variables?.filter((x) => !x.enabledIndex)
      if (filterVars && filterVars.length > 0) {
        const variable = filterVars[0]
        setDataType(variable.dataType)
        values.condition = {
          variableId: variable.id,
          condition1: 1,
          operate1: variable && variable.dataType == 0 ? 1 : 0,
          condMethod: 0,
          condition2: 1,
          operate2: 0
        }
      }
    }
    props.form.setFieldsValue(values)
  }

  useEffect(() => {
    if (props.item) {
      if (props.item.schedules && props.item.schedules.length > 0) {
        const plan = props.item.schedules[0]
        if (plan.mode == 2) {
          const variable = props.variables?.find(
            (x) => x.id == plan.condition?.variableId
          )
          setCondMethod(plan.condition?.condMethod || 0)
          setDataType(variable?.dataType)
        }
        props.form!.setFieldsValue(plan)
        setMode(plan.mode!)
      }
    }
  }, [props.item])

  return (
    <Form form={props.form} {...formItemLayout}>
      <Form.Item
        label={formatMessage({ id: 'app.template.macro.plan.mode' })}
        name='mode'
      >
        <Radio.Group onChange={(e) => hanldeModeChange(e.target.value)}>
          <Radio value={0}>
            {formatMessage({ id: 'app.template.macro.plan.mode.0' })}
          </Radio>
          <Radio value={1}>
            {formatMessage({ id: 'app.template.macro.plan.mode.1' })}
          </Radio>
          <Radio value={2}>
            {formatMessage({ id: 'app.template.macro.plan.mode.2' })}
          </Radio>
        </Radio.Group>
      </Form.Item>

      {mode == 1 && (
        <Form.Item
          label={formatMessage({ id: 'app.template.macro.plan.cycle' })}
          name='cycle'
        >
          <BetterInputNumber addonAfter='s' />
        </Form.Item>
      )}
      {mode == 2 && (
        <Form.Item
          label={formatMessage({ id: 'app.template.macro.plan.variable' })}
          name={['condition', 'variableId']}
          rules={[
            {
              required: true,
              message: formatMessage({
                id: 'app.template.macro.plan.variable.message'
              })
            }
          ]}
        >
          <Select
            showSearch
            filterOption={(input, option) =>
              option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleVariableChange}
          >
            {props.variables?.map((x) => (
              <Select.Option value={x.id!} key={x.id} disabled={x.enabledIndex}>
                {getAddressOption(x, props.plcs)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}

      {mode == 2 && dataType == 0 && (
        <Form.Item
          label={formatMessage({ id: 'app.template.macro.plan.condition' })}
          name={['condition', 'operate1']}
          rules={[
            {
              required: true,
              message: formatMessage({
                id: 'app.template.macro.plan.condition.message'
              })
            }
          ]}
        >
          <Radio.Group>
            <Radio value={1}>ON</Radio>
            <Radio value={0}>OFF</Radio>
          </Radio.Group>
        </Form.Item>
      )}

      {mode == 2 && dataType != 0 && (
        <Form.Item
          label={formatMessage({ id: 'app.template.macro.plan.condition' })}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                style={formItemStyle}
                name={['condition', 'condition1']}
              >
                <Select>{getOptions(alarmConditionItems)}</Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                style={formItemStyle}
                name={['condition', 'operate1']}
                rules={[
                  {
                    required: true,
                    message: formatMessage({
                      id: 'app.template.macro.plan.condition.message'
                    })
                  }
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                style={formItemStyle}
                name={['condition', 'condMethod']}
              >
                <Select onChange={handleCondMethodChange}>
                  {getOptions(alarmCondMethodItems)}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {condMethod != 0 && (
            <Row gutter={24} style={{ marginTop: '20px' }}>
              <Col span={8}>
                <Form.Item
                  style={formItemStyle}
                  name={['condition', 'condition2']}
                >
                  <Select>{getOptions(alarmConditionItems)}</Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  style={formItemStyle}
                  name={['condition', 'operate2']}
                  rules={[
                    {
                      required: true,
                      message: formatMessage({
                        id: 'app.template.macro.plan.condition.message'
                      })
                    }
                  ]}
                >
                  <InputNumber style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form.Item>
      )}
    </Form>
  )
}
